import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        console.error('UI error:', error, info?.componentStack);
    }

    render() {
        const { error } = this.state;
        if (!error) return this.props.children;

        return (
            <div style={{ padding: '140px 24px 40px', textAlign: 'center', color: '#0f172a' }}>
                <h2>Ocorreu um erro ao mostrar esta página</h2>
                <p style={{ fontFamily: 'monospace', fontSize: '0.85rem', wordBreak: 'break-word' }}>
                    {String(error?.message || error)}
                </p>
                <button onClick={() => window.location.reload()} style={{ marginRight: 12 }}>Recarregar</button>
                <button onClick={() => { window.location.href = '/login'; }}>Ir para login</button>
            </div>
        );
    }
}

export default ErrorBoundary;
